/**
 * PlaylistSearchTile — barrel for the comparison phase.
 *
 * Currently exposing **21-card variant grid**:
 *   • V1 × 10 animation variants (Infinity Carousel)
 *   • V3 × 10 animation variants (Cover-Flow Cinematic)
 *   • V6 (Golden Spiral)
 *
 * The dispatch lives in `AiGuideSearchPage.tsx`. After a winner is
 * picked, this barrel collapses to a single default export.
 */

export { default as PlaylistSearchTileV1 } from './variations/PlaylistSearchTileV1'
export { default as PlaylistSearchTileV3 } from './variations/PlaylistSearchTileV3'
export { default as PlaylistSearchTileV6 } from './variations/PlaylistSearchTileV6'

export type { PlaylistSearchTileProps } from './shared/types'
